import { Box, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import { useSize } from '../../hooks/useSize'
import styles from './about.module.scss'

const Access: React.FC = () => {
  const { matchTabletSize } = useSize()
  const accessPaddingBottom = matchTabletSize ? '10px' : '17px'
  return (
    <Container id="access" maxWidth="md">
      <Box pt="50px" pb="100px">
        <Typography pb="20px" variant="h2">
          アクセス
        </Typography>

        {/* ここにGoogle Map Api */}
        <Box pb="27px">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0881803406287!2d139.76535107592832!3d35.67483067258934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188be3868a6e7f%3A0x5bc33dcd95cd810c!2z44CSMTA0LTAwNjEg5p2x5Lqs6YO95Lit5aSu5Yy66YqA5bqn77yR5LiB55uu77yW4oiS77yS!5e0!3m2!1sja!2sjp!4v1745561334229!5m2!1sja!2sjp"
            title="ag capital address google map"
            width="100%"
            height="500px"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen={undefined}
            loading="lazy"
          />
        </Box>

        <Grid container>
          <Grid item sm={12} md={6}>
            <Typography variant="h2" pb={accessPaddingBottom}>
              所在地
            </Typography>
            <Typography variant="body1">〒104-0061</Typography>
            <Typography variant="body1">東京都中央区銀座一丁目６番２号 LIFE CARD 銀座ビル</Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default Access
